<template>
  <div>
    <section class="favorite_users">
      <div class="favorite_users_content">
        <div class="favorite_users_content__center">
          <div class="favorite_users_header">
            <h2>{{ getTranslations.home_achievements_title }}</h2>
            <p>{{ getTranslations.home_achievements_description }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="achievements_section top_block">
      <div class="top_block_content">
        <div class="top_block_content__center">
          <div class="top_block_header"></div>
          <div class="tab-header">
            <a v-for="(achievement, index) in achievements"
               :key="index"
               :class="[{ active: activeTab === index }, { small_font: achievements.length > 3 }]"
               href="#"
               @click.prevent="changeTab(index)">
               {{ getTranslatedValue(index + 1) }}
            </a>
          </div>
        </div>
      </div>
      <div class="tab-container">
        <achievements-tab v-for="(achievement, index) in achievements"
                          :key="index"
                          :is-active="activeTab === index"
                          :categories="achievement.achievementDTOs"/>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AchievementsTab from '@/components/home/achievements/AchievementsTab';

export default {
  name: 'achievements',
  components: {
    AchievementsTab,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },
    getTranslatedValue(index) {
      return this.getTranslations[`home_achievements_category${index}`];
    },
  },
  computed: {
    ...mapState('profile', [
      'achievements',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/achievements/Achievements.vue